/**
 * @generated SignedSource<<a2686d03bf6edee3e86f59d974d94280>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserShortCard_user$data = {
  readonly backgroundPhoto: {
    readonly id: string;
  } | null | undefined;
  readonly firstName: string;
  readonly lastName: string;
  readonly slugId: string;
  readonly " $fragmentSpreads": FragmentRefs<"UserBackgroundPhoto_user" | "UserPrimaryPhoto_user">;
  readonly " $fragmentType": "UserShortCard_user";
};
export type UserShortCard_user$key = {
  readonly " $data"?: UserShortCard_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserShortCard_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserShortCard_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slugId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "backgroundPhoto",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserPrimaryPhoto_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserBackgroundPhoto_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "babed60ad289c984547126751ec66d14";

export default node;
